import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EidosLightFormComponent, IEidosLightFormField } from '../../eidos-light-form/eidos-light-form.component';
import { ModalRef } from '@app/core/services/core-modal.service';

@Component({
  selector: 'core-form-modal',
  templateUrl: './core-form-modal.component.html',
  styleUrls: ['./core-form-modal.component.scss']
})
export class CoreFormModalComponent implements OnInit {
  @Input() modalData!: { fields: IEidosLightFormField[], values: any, mode?: string };
  @Input() modalRef!: ModalRef;

  @ViewChild('modalForm', { static: true }) modalForm!: EidosLightFormComponent;

  ngOnInit(): void {
    if (!this.modalData.values) this.modalData.values = {};
  }

  onCloseModalClick(isSubmit?: boolean) {
    isSubmit ? this.modalForm.handleFormSubmit() : this.modalRef.close(undefined);
  }

  onFormSubmit() {
    this.modalRef.close(this.modalData.values);
  }
}
